import EmptyWalletIcon from './empty-wallet.svg'
import MessageQuestionIcon from './message-question.svg'
import ShoppingCartIcon from './shopping-cart.svg'
import TaskSquareIcon from './task-square.svg'
import UserSquareIcon from './user-square.svg'
import VerifyIcon from './verify.svg'
import PlusIcon from './plus.svg'
import EyeIcon from './eye.svg'
import EyeSlashIcon from './eye-slash.svg'
import ArrowDownIcon from './arrow-down.svg'
import BriefcaseIcon from './briefcase.svg'
import RepeatIcon from './repeat.svg'
import MenuIcon from './menu.svg'
import CrossIcon from './cross.svg'
import ImportIcon from './import.svg'
import TrashIcon from './trash.svg'
import TickCircleIcon from './tick-circle.svg'
import DangerIcon from './danger.svg'
import InfoCircleIcon from './info-circle.svg'
import Edit2Icon from './edit-2.svg'
import WbIcon from './wb.svg'
import OzonIcon from './ozon.svg'
import BoxIcon from './box.svg'
import GalleryIcon from './gallery.svg'
import VideoIcon from './video-square.svg'
import CoinIcon from './coin.svg'
import XlsIcon from './xls.svg'
import SendSquareIcon from './send-square.svg'
import TextIcon from './text.svg'
import ChartIcon from './chart.svg'
import ArrowLeftIcon from './arrow-left.svg'
import TokensIcon from './tokens.svg'
import RefreshIcon from './refresh.svg'
import ExportIcon from './export.svg'
import GalleryImportIcon from './gallery-import.svg'
import LinkIcon from './link.svg'
import CheckIcon from './check.svg'
import SortIcon from './sort.svg'
import SortAscIcon from './sort-asc.svg'
import FilterIcon from './filter.svg'
import SearchIcon from './search.svg'
import KebabIcon from './kebab.svg'
import CameraIcon from './camera.svg'
import SearchClearIcon from './search-clear.svg'
import MinusIcon from './minus.svg'

export type IconName =
    | 'empty-wallet'
    | 'message-question'
    | 'shopping-cart'
    | 'task-square'
    | 'user-square'
    | 'verify'
    | 'plus'
    | 'eye'
    | 'eye-slash'
    | 'arrow-down'
    | 'briefcase'
    | 'repeat'
    | 'menu'
    | 'cross'
    | 'import'
    | 'trash'
    | 'tick-circle'
    | 'danger'
    | 'info-circle'
    | 'edit-2'
    | 'wb'
    | 'ozon'
    | 'box'
    | 'gallery'
    | 'video-square'
    | 'coin'
    | 'xls'
    | 'send-square'
    | 'text'
    | 'chart'
    | 'arrow-left'
    | 'tokens'
    | 'refresh'
    | 'export'
    | 'gallery-import'
    | 'link'
    | 'check'
    | 'sort'
    | 'sort-asc'
    | 'filter'
    | 'search'
    | 'kebab'
    | 'camera'
    | 'search-clear'
    | 'minus'

export {
    EmptyWalletIcon,
    MessageQuestionIcon,
    ShoppingCartIcon,
    TaskSquareIcon,
    UserSquareIcon,
    VerifyIcon,
    PlusIcon,
    EyeIcon,
    EyeSlashIcon,
    ArrowDownIcon,
    BriefcaseIcon,
    MenuIcon,
    CrossIcon,
    ImportIcon,
    TrashIcon,
    TickCircleIcon,
    DangerIcon,
    InfoCircleIcon,
    Edit2Icon,
    BoxIcon,
    GalleryIcon,
    VideoIcon,
    CoinIcon,
    XlsIcon,
    SendSquareIcon,
    TextIcon,
    ChartIcon,
    ArrowLeftIcon,
    TokensIcon,
    RefreshIcon,
    ExportIcon,
    GalleryImportIcon,
    LinkIcon,
    CheckIcon,
    SortIcon,
    SortAscIcon,
    FilterIcon,
    SearchIcon,
    KebabIcon,
    CameraIcon,
    SearchClearIcon,
    MinusIcon,
}

export const icons = {
    'empty-wallet': EmptyWalletIcon,
    'message-question': MessageQuestionIcon,
    'shopping-cart': ShoppingCartIcon,
    'task-square': TaskSquareIcon,
    'user-square': UserSquareIcon,
    'eye-slash': EyeSlashIcon,
    'arrow-down': ArrowDownIcon,
    plus: PlusIcon,
    verify: VerifyIcon,
    eye: EyeIcon,
    briefcase: BriefcaseIcon,
    repeat: RepeatIcon,
    menu: MenuIcon,
    cross: CrossIcon,
    import: ImportIcon,
    trash: TrashIcon,
    'tick-circle': TickCircleIcon,
    danger: DangerIcon,
    'info-circle': InfoCircleIcon,
    'edit-2': Edit2Icon,
    wb: WbIcon,
    ozon: OzonIcon,
    box: BoxIcon,
    gallery: GalleryIcon,
    'video-square': VideoIcon,
    coin: CoinIcon,
    xls: XlsIcon,
    'send-square': SendSquareIcon,
    text: TextIcon,
    chart: ChartIcon,
    'arrow-left': ArrowLeftIcon,
    tokens: TokensIcon,
    refresh: RefreshIcon,
    export: ExportIcon,
    'gallery-import': GalleryImportIcon,
    link: LinkIcon,
    check: CheckIcon,
    sort: SortIcon,
    'sort-asc': SortAscIcon,
    filter: FilterIcon,
    search: SearchIcon,
    kebab: KebabIcon,
    camera: CameraIcon,
    'search-clear': SearchClearIcon,
    minus: MinusIcon,
}
